import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const ActivateFlow = async (domain: string, flowId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/activate-flow`,
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}